/* eslint-disable @typescript-eslint/naming-convention */
import type {
  SecondaryNavigationBlock,
  SupportNavigationBlock
} from '@ps/web-martech-cms-types/SiteHeader';
import { Link, RawButton, useResolver } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import styles from './CMSHeaderMenu.scss';
import Icon from './Icon';

type Props = (SupportNavigationBlock | SecondaryNavigationBlock) & {
  className?: string;
  onClick?: () => void;
};

const ResolverLink: React.FC<Props> = ({
  url,
  resolver_tag,
  title,
  className,
  icon,
  track_id,
  target,
  onClick
}) => {
  let href = useResolver(resolver_tag);
  if (!resolver_tag) {
    href = url || '';
  }

  if (icon === 'PrimaryButton' || icon === 'SecondaryButton') {
    const variant = icon === 'PrimaryButton' ? 'primary' : 'secondary';
    return (
      <RawButton
        href={url}
        inverse
        size="small"
        variant={variant}
        className={styles.buttonLink}
        onClick={onClick}
      >
        {title}
      </RawButton>
    );
  }

  return (
    <Link
      href={href}
      target={target || undefined}
      trackText={track_id}
      className={classNames(className, styles.menuLink)}
      onClick={onClick}
    >
      <Icon icon={icon?.toLowerCase()} className={styles.icon} />
      {title}
    </Link>
  );
};

export default ResolverLink;
